export default __webpack_public_path__ + "static/media/styled-component-icon.0fefccb0.png";